import React from 'react';
import PropTypes from 'prop-types';
import ReactAutosuggest from 'react-autosuggest';
import humanize from 'underscore.string/humanize';
import underscored from 'underscore.string/underscored';

import ValueViewer from './value-viewer';
import Messages, {messagesShape} from '../messages';
import FormGroup from './form-group';
import theme from './autosuggest-theme.css';


export default class Autosuggest extends React.Component {

  static propTypes = {
    readOnly: PropTypes.bool.isRequired,
    messages: messagesShape.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string
  };

  static defaultProps = {
    readOnly: false,
    messages: [],
    name: '',
  };

  get Label() {
    const {label, name} = this.props;
    if (!label && !name) {
      return null;
    } else {
      return (
        <label htmlFor={underscored(name)}>
          {label ? label : humanize(name)}:
        </label>);
    }
  }

  render() {
    const {readOnly, messages, ...props} = this.props;
    return (
      <FormGroup>
        {this.Label}
        {readOnly ?
          <ValueViewer
           readOnly={readOnly}
           emptyText="None">
            {(props.inputProps || {}).value}
          </ValueViewer> :
          <ReactAutosuggest theme={theme} {...props} />}
        {messages.length ? <Messages messages={messages} /> : null}
      </FormGroup>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/fragments/forms/autosuggest.js